<template>
  <div class="wrapper">
    <div class="img_wrapper">
      <img src="../../assets/images/h5/h5.jpeg">
    </div>
    <div class="bottom">
      <img src="../../assets/images/h5/h5-01.jpeg" @click="click()">
      <p> 山东依智教育科技有限公司</p>
    </div>
    <!--弹框-->
    <div class="dig_wrap">
      <mt-popup v-model="popupVisible">
        <p class="close" @click="close()">X</p>
        <div class="dig_box">
          <mt-field label="姓名:" placeholder="请输入您的姓名" type="realName" v-model.trim="realName"></mt-field>
          <mt-field label="手机号:" placeholder="请输入您的手机号" type="tel" v-model.trim="mobile"></mt-field>
          <mt-button type="primary" @click="save()">立即支付</mt-button>
        </div>
      </mt-popup>
    </div>
  </div>

</template>
<script>
import {orderAdd, landingPageOrder} from "../../apis/apis";
import {Toast} from 'mint-ui';

export default {
  components: {},
  name: "",
  data() {
    return {
      popupVisible: false,
      mobile: "", //手机号
      realName: "", //姓名
      orderNo: "",
    }
  },
  methods: {
    click() {
      this.popupVisible = true;
    },
    save() {
      if (this.realName == "") {
        // Toast("请输入您的姓名！");
        Toast({
          message: '请输入您的姓名！',
          position: 'bottom',
        });
        return
      }
      if (this.mobile == "") {
        // Toast("请输入您的电话！");
         Toast({
          message: '请输入您的电话！',
          position: 'bottom',
        });
        return
      }
      this.confirmRmbPay();
    },
    close() {
      this.popupVisible = false;
    },
// 判断是否在微信浏览器  1为微信浏览器 2为其他  这个方法定义在外面，后面也会用到
    _isweixin() {
      return new Promise((resolve) => {
        const ua = window.navigator.userAgent.toLowerCase();
        //userAgent 属性是一个只读的字符串，声明了浏览器用于 HTTP 请求的用户代理头的值。
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          resolve(1);
        } else {
          resolve(2);
        }
      });
    },
    // 确认人民币付款
    async confirmRmbPay() {
      const params = {
        mobile: this.mobile,
        realName: this.realName,
        totalPrice: "1.3"
      };
      const isweixin = await this._isweixin();
      if (isweixin === 2) {
        // alert("请在微信以外的浏览器里打开并支付!");
        orderAdd(params).then((res) => {
          console.log(res, res)
          console.log(res, res.data.code)
          if (res.data.code === 200) {
            // 调用直接跳转后台返回给你的url地址，类似下面的地址
            this.pageUrl = res.data.data.jsConfig.mwebUrl;
            window.location.href = this.pageUrl + '&redirect_url=' + 'http://m.yzvet.com/h5page';
            // if (res.data.data.orderNo) {
            //   this.orderNo = res.data.data.orderNo;
            //   this.$router.push({
            //     name: "/h5OrderInfo",
            //     query: {
            //       orderNo: this.orderNo
            //     }
            //   });
            // }
          } else {
            Toast(res.message);
          }
        }).catch(() => {
        });
      } else {
      }
    },
  },
  mounted() {
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
}

.img_wrapper {
  width: 100%;
  height: 100%;
}

.img_wrapper img {
  width: 100%;
}

.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  background: #FFFFFF;
}

.bottom img {
  width: 100%;
}

.close {
  padding: 30px;
  font-size: 36px;
  text-align: right;
  color: #333;
}

.bottom p {
  font-size: 30px;
  padding: 20px;
  text-align: center;
  color: #666;
}

/*弹框*/

.dig_wrap {
  width: 100%;
  background: #FFFFFF;
}

.dig_box {
  width: 100%;
  background: #FFFFFF;
  text-align: center;
}

.dig_wrap >>> .mint-popup {
  width: 95%;
  margin: 0 auto;
  height: 700px;
  border-radius: 30px;
}

.dig_wrap >>> .mint-popup-bottom {
  width: 100%;
  height: 600px;
}

.dig_wrap >>> .mint-cell-wrapper {
  height: 100px;
  border: 1px solid #ededed;
  border-radius: 10px;
  margin: 20px;
}

.dig_wrap >>> .mint-cell-text {
  font-size: 32px;
}

.dig_wrap >>> .mint-field-core {
  font-size: 32px;
  padding-left: 10px;
}

.dig_wrap>>>.mint-button--normal {
  text-align: center;
  padding: 0px;
  font-size: 40px;
  font-weight: bold;
  width: 500px;
  height: 100px;
  border-radius: 50px;
  margin-top: 50px;
}

.dig_wrap >>> .mint-toast {
  z-index: 3000!important;
}

.dig_wrap >>> .v-modal {
  z-index: 999 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/h5Page.vue